import React from 'react';
import PaymentBilling from './PaymentBilling';
import SubscriptionPlans from './SubscriptionPlans';
import './styles.scss';

export default function SettingsBilling() {
  return (
    <div className="settings-billing">
      <PaymentBilling />
      <div className="settings-billing__column-two">
        <SubscriptionPlans />
      </div>
    </div>
  );
}
